import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.table = [];
    this.cardsLayout = [
      // cards
      {
        title: "Mailing Address",
        items: [
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "mailName",
              noInput: true
            },
            size: "100%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "mailAddress",
              noInput: true
            },
            size: "100%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "mailCity",
              noInput: true
            },
            size: "100%",
            readOnly: true
          }
        ]
      },
      {
        title: "Shipping Address",
        items: [
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "shipName",
              noInput: true
            },
            size: "100%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "shipAddress",
              noInput: true
            },
            size: "100%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "shipCity",
              noInput: true
            },
            size: "100%",
            readOnly: true
          }
        ]
      },
      {
        title: "Card3",
        hideTitle: true,
        items: [
          {
            label: {
              value: "Vendor Group",
              size: "calc(30%)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vendorGroup"
            },
            size: "100%",
            readOnly: true
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Contact Name",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "ContactName"
            },
            size: "30%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Phone",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "ContactPhone"
            },
            size: "30%"
          },
          {
            label: {
              value: ""
            },
            span: {
              value: "Title",
              alignment: "center",
              size: "100%"
            },
            item: {
              node: "onlySpan",
              value: "",
              intemName: "ContactTitle"
            },
            size: "40%"
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact1Name",
              noInput: true
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact1Phone",
              noInput: true
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact1TitleText",
              noInput: true
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact2Name",
              noInput: true
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact2Phone",
              noInput: true
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact2TitleText",
              noInput: true
            },
            size: "40%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact3Name",
              noInput: true
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact3Phone",
              noInput: true
            },
            size: "30%",
            readOnly: true
          },
          {
            label: {
              value: ".",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "contact3TitleText",
              noInput: true
            },
            size: "40%",
            readOnly: true
          }
        ]
      },
      {
        title: "Card4",
        hideTitle: true,
        items: [
          {
            label: {
              value: "EP Returns",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "epReturns"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "VDP Days",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vendorDirectDays"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "Cutoff Time",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdpCutOffTime"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "Last Pull Time",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdpVendPullTime"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "VDP Freight Code",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdpFreight"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "Start Date",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdpStartDate"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "Timezone",
              size: "auto"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vdpVendTimeZone"
            },
            readOnly: true,
            size: "calc(100% / 7)"
          },
          {
            label: {
              value: "VDP Run Schedule",
              align: "center"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "VDPRunSchedule",
              noInput: true
            },
            size: "12%",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "7AM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpAM07"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "8AM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpAM08"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "9AM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpAM09"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "10AM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpAM10"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "11AM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpAM11"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "12PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM12"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "1PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM01"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "2PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM02"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "3PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM03"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "4PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM04"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "5PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM05"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "6PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM06"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "7PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM07"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "8PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM08"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "9PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM09"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {},
            span: { fontSize: "90%", value: "10PM" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "vdpPM10"
            },
            size: "calc(88% / 16)",
            readOnly: true
          },
          {
            label: {
              value: "Auto Cancel DSD",
              size: "calc(100% - 30px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "dsdAutoCancel"
            },
            size: "13%",
            readOnly: true
          },
          {
            label: {},
            span: { value: "Days" },
            item: {
              node: "input",
              noLabel: true,
              type: "number",
              value: "",
              intemName: "dsdAutoCancelDays"
            },
            size: "6%",
            readOnly: true
          },
          {
            label: {
              value: "Code of Conduct",
              size: "calc(100% - 50px)",
              fontSize: "92%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "codeConductDate"
            },
            size: "23.8%",
            readOnly: true
          },
          {
            label: {
              value: "PM",
              size: "50%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "designated"
            },
            size: "6%",
            readOnly: true
          },
          {
            label: {
              value: "Date Agreement Signed",
              size: "calc(100% - 92px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "agreementSignDate"
            },
            size: "22.6%",
            readOnly: true
          },
          {
            label: {
              value: "Mail Order",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "mailOrder"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Order Method",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "orderMethod"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },

          {
            label: {
              value: "Forecast Year",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastPeriods"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast Length",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastLength"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast Type",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastType"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast Display",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastDisp"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast Pad",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastPad"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast Net Inv",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastNet"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast File",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastFile"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "Forecast New Items",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "forecastNewItems"
            },

            size: "calc(18.2857%)",
            readOnly: true
          },
          {
            label: {
              value: "Ship Method",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "shipMethod"
            },
            size: "calc(100% / 7)",
            readOnly: true
          },
          {
            label: {
              value: "SCAC Code",
              size: "calc(100% - 76px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "vendScacCode"
            },
            size: "calc(14.2857%)",
            readOnly: true
          },
          {
            label: {
              value: "POS Flag",
              size: "calc(100% - 50px)",
              fontSize: "98%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "posFlag"
            },
            size: "calc(10.2857%)",
            readOnly: true
          },
          {
            label: {
              value: "FRR",
              size: "calc(100% - 50px)"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "rightReturnFlag"
            },
            size: "calc(100% / 7)",
            readOnly: true
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value = props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
            item.item.injectedValue = props[c][inputName][i].injectedValue;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <Fragment>
        <div style={{ flex: 1 }}>
          <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1, display: "flex" }}>
              <InputCard
                flex={1}
                jsonObj={this.cardsLayout[0]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
              <InputCard
                flex={1}
                jsonObj={this.cardsLayout[1]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
              <InputCard
                flex={2}
                jsonObj={this.cardsLayout[2]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
            </div>
            <div style={{ flex: 3 }}>
              <InputCard
                justifyContent={"center"}
                jsonObj={this.cardsLayout[3]}
                setCardsInfo={this.getCardsInfo}
                functions={{
                  checkOrderConstraints: this.props.checkOrderConstraints
                }}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  getTheJson = () => {
    for (let index = 0; index < this.cardsLayout.length; index++) {
      for (let i = 0; i < this.cardsLayout[index].items.length; i++) {
      }

    }
  };

  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
